<template>
  <div class="accreditor-page">
    <v-card class="accreditor-card">
      <div class="accreditor-header">
        <div class="accreditor-header__copy">
          <div class="accreditor-title">Accreditors</div>
          <div class="accreditor-subtitle">Manage accreditor records and renewals.</div>
        </div>
        <v-text-field
            v-model="search"
            class="accreditor-search"
            append-icon="mdi-magnify"
            hide-details
            label="Search"
            single-line
        ></v-text-field>
        <v-btn
            v-if="canCreateAccreditor"
            class="accreditor-add-button"
            depressed
            @click="AddAccreditor()"
        >
          <v-icon left>mdi-plus-circle</v-icon>
          <span>Add Accreditor</span>
        </v-btn>
      </div>
      <v-data-table
          :headers="headers"
          :items="accreditors.rows"
          :loading="loading"
          :options.sync="options"
          :server-items-length="accreditors.count"
          class="accreditor-table elevation-1"
          loading-text="Loading... please wait"
      >
        <template v-slot:[`item.accreditorName`]="{ item }">
          <label for="item">{{
              item.accreditorName ? item.accreditorName : "-"
            }}</label>
        </template>
        <template v-slot:[`item.accreditorGeolocation`]="{ item }">
          <label for="item">{{
              item.accreditorGeolocation ? item.accreditorGeolocation : "-"
            }}</label>
        </template>
        <template v-slot:[`item.accredatorOwnership.name`]="{ item }">
          <label for="item">{{
              item.accredatorOwnership ? item.accredatorOwnership.name : "-"
            }}</label>
        </template>
        <template v-slot:[`item.accreditationCode`]="{ item }">
          <label for="item">{{
              item.accreditationCode ? item.accreditationCode : "-"
            }}</label>
        </template>
        <template v-slot:[`item.isActive`]="{ item }">
          <v-chip :color="getColor(item)" dark>
            {{ getStatusLabel(item) }}
          </v-chip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <div class="accreditor-action-group">
            <v-tooltip bottom>
              <template v-if="canViewAccreditor" v-slot:activator="{ on }">
                <v-icon
                    class="accreditor-action-icon"
                    @click="viewAccreditor(item)"
                    v-on="on"
                >mdi-eye
                </v-icon
                >
              </template>
              <span>View Accreditor</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-if="canEditAccreditor(item.createdById, item.id)" v-slot:activator="{ on }">
                <v-icon
                    class="accreditor-action-icon"
                    @click="editAccreditor(item)"
                    v-on="on"
                >mdi-circle-edit-outline
                </v-icon
                >
              </template>
              <span>Edit Accreditor</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-if="canRenewAccreditor()" v-slot:activator="{ on }">
                <v-icon
                    class="accreditor-action-icon"
                    @click="renewAccreditor(item)"
                    v-on="on"
                >mdi-autorenew
                </v-icon
                >
              </template>
              <span>Renew Accreditor</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <template>
      <v-dialog v-model="dialog" persistent width="60%">
        <v-card class="accreditor-dialog-card">
          <v-card-title
              class="accreditor-dialog__title"
              primary-title
          >{{ title }}

            <v-spacer></v-spacer>

            <v-btn class="accreditor-dialog__close" icon @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title
          >

          <v-divider></v-divider>
          <HrdAddAccreditor
              v-if="dialog"
              :accreditor="accreditor"
              @close="closeDialog()"
              @registerOrUpdateAccreditor="registerOrUpdateAccreditor"
          ></HrdAddAccreditor>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog v-model="detailDialog" persistent width="60%">
        <v-card class="accreditor-dialog-card">
          <v-card-title
              class="accreditor-dialog__title"
              primary-title
          >
            {{ title }}

            <v-spacer></v-spacer>

            <v-btn class="accreditor-dialog__close" icon @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-divider></v-divider>
          <HrdDetailAccreditor
              v-if="detailDialog"
              :accreditor="accreditor"
          ></HrdDetailAccreditor>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog v-model="renewalDialog" persistent width="60%">
        <v-card class="accreditor-dialog-card">
          <v-card-title
              class="accreditor-dialog__title"
              primary-title
          >{{ title }}

            <v-spacer></v-spacer>

            <v-btn class="accreditor-dialog__close" icon @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title
          >

          <v-divider></v-divider>
          <v-card
              class="accreditor-renewal-card my-2 mb-6"
              outlined
              style="background-color: whitesmoke"
          >
            <div class="accreditor-renewal__section">
              <v-row align="center" class="accreditor-renewal__row">
                <v-col cols="12" md="6" class="required">
                  <label
                      class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
                  >Renew Date:
                  </label>
                  <validation-provider v-slot="{ errors }" rules="required">
                    <v-menu
                        ref="menu"
                        v-model="startMenu"
                        :close-on-content-click="false"
                        max-width="290px"
                        min-width="290px"
                        offset-y
                        transition="scale-transition"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="formValues.accreditedDate"
                            label="Renew date"
                            persistent-hint
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          ref="accreditationDate"
                          v-model="formValues.accreditedDate"
                          :max="date"
                          no-title
                          scrollable
                          @input="startMenu = false"
                      ></v-date-picker>
                    </v-menu>
                    <span class="text-gray-600 text-xs italic text-red-700">{{
                        errors[0]
                      }}</span>
                  </validation-provider>
                </v-col>
                <v-col cols="12" md="6" class="accreditor-renewal__action">
                  <v-btn
                      class="accreditor-renewal__button"
                      color="primary"
                      @click="addRenewal()"
                  >
                    <v-icon left>mdi-autorenew</v-icon>
                    Renew
                  </v-btn>
                </v-col>
              </v-row>
            </div>
            <v-divider></v-divider>
            <div class="accreditor-renewal__section">
              <v-data-table
                  :headers="renewalHeader"
                  :items="renewals"
                  :loading="loading"
                  :server-items-length="renewals.length"
                  class="elevation-1 accreditor-renewal__table"
                  loading-text="Loading... please wait"
              ></v-data-table>
            </div>
          </v-card>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import {accessPolicy} from "@/utils/managedAccess";
import {extend, ValidationProvider} from "vee-validate";
import {getUser} from "@/utils/helper";
import HrdAddAccreditor from "./hrd-add-accreditor";
import HrdDetailAccreditor from "./hrd-accreditor-detail";
import {AccreditorService} from "./accreditor.service";
import {required} from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: "This field is required",
});

export default {
  components: {
    HrdAddAccreditor,
    HrdDetailAccreditor,
    ValidationProvider,
  },
  data() {
    return {
      search: "",
      searchDebounce: null,
      accreditor: null,
      title: "",
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      loading: false,
      dialog: false,
      detailDialog: false,
      renewalDialog: false,
      headers: [
        {text: "Accreditor Name", value: "accreditorName"},
        {text: "Accreditor's Geolocation", value: "region.name"},
        {text: "Accreditor's Ownership", value: "accredatorOwnership.name"},
        {text: "Accreditation Code", value: "accreditationCode"},
        {text: "Accreditor's Status", value: "isActive", align: "center"},
        {text: "Actions", value: "actions", sortable: false, align: "center"},
      ],
      accreditors: [],

      date: new Date().toISOString().substr(0, 10),
      startMenu: false,
      formValues: {
        accreditedDate: "",
        accreditedBy: null,
        cpdId: null,
        accreditorId: null,
      },
      renewalHeader: [
        {text: "Previous Accredited Date", value: "accreditedDate"},
        {text: "Accredited By", value: "user.firstName"},
      ],
      renewals: [],
    };
  },
  async beforeMount() {
    this.fetchAccreditorList();
  },
  watch: {
    options: {
      handler() {
        this.fetchAccreditorList();
      },
      deep: true,
    },
    search: function (val) {
      if (this.searchDebounce) {
        clearTimeout(this.searchDebounce);
        this.searchDebounce = null;
      }
      const text = (val || "").toString().trim();
      if (text.length === 0) {
        this.fetchAccreditorList();
        return;
      }
      if (text.length < 3) {
        return;
      }
      this.searchDebounce = setTimeout(() => {
        this.fetchAccreditorList();
      }, 400);
    },
  },
  computed: {
    isReadOnly() {
      return Boolean(getUser()?.data?.readOnly);
    },
    canCreateAccreditor() {
      return !this.isReadOnly && getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "CPD Accreditor" &&
              permission.canCreate
      );
    },
    canViewAccreditor() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "CPD Accreditor" && permission.canRead
      );
    },
  },
  methods: {
    AddAccreditor() {
      this.accreditor = null;
      this.dialog = true;
      this.title = "Add Accreditor";
    },
    viewAccreditor(item) {
      this.accreditor = item;
      this.detailDialog = true;
      this.title = "Accreditor Detail";
    },
    canEditAccreditor(id, accId) {
      const policy = accessPolicy(getUser());
      if (policy) return this.$can("accreditor","edit") && (policy.organization?.kind === "ministry" || Number(getUser().data?.id) === Number(id) || Number(getUser().data?.accreditorId) === Number(accId) || policy.organization?.kind === "regional");
      return (!this.isReadOnly && (getUser().data?.userRoles?.roleName == "System admins" ||
          (getUser().permissions.some(
                  (permission) =>
                      permission.menuItem.menuItemName == "Accreditor" &&
                      permission.canUpdate &&
                      (getUser().data?.['id'] == id ||
                          getUser().data?.['accreditorId'] == accId))
          )));
    },
    editAccreditor(item) {
      this.accreditor = item;
      this.title = "Edit Accreditor";
      this.dialog = true;
      //   this.changeTAccreditorUsedNo = 0;
      //   this.changeAccreditorOwnerNo = 0;
    },
    canRenewAccreditor() {
      return !this.isReadOnly && this.$can("accreditor","renew",getUser().data?.userRoles?.roleName == "System admins");
    },
    renewAccreditor(item) {
      this.accreditor = item;
      this.title = "Renew Accreditor";
      this.renewalDialog = true;
      const today = this.getTodayDate();
      this.date = today;
      this.formValues = {
        accreditedDate: today,
        accreditedBy: null,
        cpdId: null,
        accreditorId: item.id,
      };
      this.fetchRenewalList(item.id);
    },
    closeDialog() {
      this.dialog = false;
      this.detailDialog = false;
      this.renewalDialog = false;
      this.fetchAccreditorList();
    },
    async registerOrUpdateAccreditor(accreditor) {
      let res = null;
      const user = JSON.parse(localStorage.getItem('user'));
      const userId = user.data.id;

      if (accreditor.editMode) {
        res = await AccreditorService.update(accreditor.id, accreditor);

        if (res.status === 201) {
          switch (res.data.status) {
            case 200:
              this.$toast.success(res.data.message);
              this.fetchAccreditorList();
              break;
            case 500:
              this.$toast.error(res.data.message);
              break;
          }
        } else {
          this.$toast.error("Unable to update accreditor, please try again");
        }
      } else {

        accreditor.createdById = userId;
        res = await AccreditorService.create(accreditor);

        if (res.status === 200) {
          switch (res.data.status) {
            case 200:
              this.$toast.success(res.data.message);
              this.formValues.accreditorId = res.data.data.id;
              this.formValues.accreditedDate = res.data.data.accreditationDate;
              await AccreditorService.addRenewal(this.formValues)
                  .then(this.fetchAccreditorList());
              break;
            case 500:
              this.$toast.error(res.data.message);
              break;
          }
        } else {
          this.$toast.error("Unable to create accreditor, please try again");
        }
      }

    },
    async fetchAccreditorList() {
      this.loading = true;
      const {page, itemsPerPage} = this.options;
      const res = await AccreditorService.getAccreditorListWP(
          page,
          itemsPerPage,
          this.search
      );
      if (res.status === 200) {
        this.loading = false;
        this.accreditors = res.data;
      } else {
        this.loading = false;
        this.$toast.error(
            "There was a problem fetching Accreditors, Please try Again!"
        );
      }
    },
    async fetchRenewalList(id) {
      this.loading = true;
      const res = await AccreditorService.getRenewals(id);
      if (res.status === 200) {
        this.loading = false;
        this.renewals = res.data;
      } else {
        this.loading = false;
        this.$toast.error(
            "There was a problem fetching Renewals, Please try Again!"
        );
      }
    },
    async addRenewal() {
      if (!this.formValues.accreditedDate) {
        this.formValues.accreditedDate = this.getTodayDate();
      }
      const res = await AccreditorService.addRenewal(this.formValues);
      if (res.status === 200) {
        this.$toast.success(res.data.message);
        this.closeDialog();
      } else {
        this.$toast.error(res.data.message);
      }
    },
    getStatusLabel(item) {
      if (item?.statusLabel) {
        return item.statusLabel;
      }
      return item?.isActive === false ? "Not Active" : "Active";
    },
    getColor(item) {
      const status = this.getStatusLabel(item);
      if (status === "Expired") return "orange darken-2";
      if (status === "Not Active") return "red";
      return "green";
    },
    getTodayDate() {
      return new Date().toISOString().substr(0, 10);
    },
  },
};
</script>

<style scoped>
.accreditor-page {
  padding: 24px;
  background: #f5f7fb;
  min-height: 100%;
}

.accreditor-card {
  border-radius: 0 0 12px 12px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);
  overflow: hidden;
}

.accreditor-header {
  display: grid;
  grid-template-columns: minmax(220px, 1fr) minmax(240px, 360px) auto;
  align-items: center;
  gap: 16px;
  padding: 24px 28px;
}

.accreditor-header__copy {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.accreditor-title {
  font-size: 24px;
  font-weight: 700;
  color: #0f172a;
}

.accreditor-subtitle {
  font-size: 14px;
  color: #475569;
}

.accreditor-search {
  width: 100%;
  max-width: 360px;
  justify-self: center;
  align-self: center;
}

.accreditor-table {
  border-radius: 0 0 12px 12px;
}

.accreditor-dialog-card {
  border-radius: 10px;
  overflow: hidden;
}

.accreditor-dialog__title {
  display: flex;
  align-items: center;
  gap: 16px;
  background: #3a4f63;
  color: #ffffff;
  padding: 20px 24px;
}

.accreditor-dialog__close {
  color: #ffffff !important;
}

.accreditor-dialog__close .v-icon {
  color: #ffffff !important;
}

.accreditor-add-button {
  background: #1976d2 !important;
  border-color: #1976d2 !important;
  color: #ffffff !important;
  text-transform: none;
  font-weight: 600;
}

.accreditor-action-icon {
  color: #1976d2 !important;
}

.accreditor-action-group {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-wrap: nowrap;
  white-space: nowrap;
}

.accreditor-action-group .v-tooltip {
  display: inline-flex;
}

.accreditor-renewal-card {
  padding: 8px 0;
}

.accreditor-renewal__section {
  padding: 12px 16px;
}

.accreditor-renewal__row {
  margin: 0;
}

.accreditor-renewal__action {
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  padding-top: 22px;
}

.accreditor-renewal__button {
  text-transform: none;
  font-weight: 600;
}

.accreditor-renewal__table {
  border-radius: 8px;
}

@media (max-width: 700px) {
  .accreditor-page {
    padding: 12px;
  }

  .accreditor-header {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 20px;
  }

  .accreditor-search {
    max-width: 100%;
  }

  .accreditor-add-button {
    width: 100%;
    justify-content: center;
  }

  .accreditor-renewal__action {
    padding-top: 0;
  }
}
</style>
